import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderData } from 'src/app/_models/header-data';
import { RenewalsService } from '../../_services/renewals.service';
import { DICE_RENEWALS_CONFIG, FILE_UPLOAD_CONFIG, RENEWAL_MSGS, RESULTS_NOT_FOUND } from '../../../_common/product-config';
import { RenewalSteps } from 'src/app/_common/_enum/module.enum';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import LogRocket from 'logrocket';
import { BindAndIssueBasicInfoComponent } from '../bind-and-issue-basic-info/bind-and-issue-basic-info.component';
import { BindAndIssueReviewComponent } from '../bind-and-issue-review/bind-and-issue-review.component';
import { BindRenewal, RenewalBindMethods } from '../../_models/bind-renewal';

@Component({
  selector: 'app-bind-and-issue',
  templateUrl: './bind-and-issue.component.html',
  styleUrls: ['./bind-and-issue.component.scss']
})
export class BindAndIssueComponent implements OnInit {

  //Create HeaderData object to show the Data on Blue Header.
  private headerData: HeaderData;

  private bannerMsgs = DICE_RENEWALS_CONFIG.BannerMessages;
  private loading: boolean = false;
  private lookupReferenceData: any;
  private renewalNumber: any;

  private bindData: any; //While fetching Bind data on initial screen load
  private submitLoading: boolean = false;
  private _renewal: BindRenewal;
  private _renewalsMethods: RenewalBindMethods;
  private RenewalSteps = RenewalSteps;
  private renewalAccountData;
  private modalReference;
  private isSubmitted: boolean = false;
  private renewalData: any;
  private resultsNotFound = RESULTS_NOT_FOUND; //Using it in HTML
  private renewalMsgs = RENEWAL_MSGS; //Using it in HTML
  private fileUploadConfig = FILE_UPLOAD_CONFIG; //Using it in HTML
  private uploadedFileSize: number = 0;
  private finalResponse: any;
  private bniFormModel = {
    renewalNumber: 443,
    billingType: "Agency",
    paymentPlan: "B - Semi-Annual",
    comment: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    renewingPolicies: [
      {
        policyNumber: "PR202000006243",
        quoteDocument: {
          "id": "6720609",
          "name": "Quote Letter",
          "description": "QUOTE - Quote C",
          "changeDate": "2021-07-06T15:45:53",
          "iteration": "Quote C",
          "isQuoteLatest": true
        },      
        isSubjectivities: true,
        coverages: [
          {
            name: "Property",
            lobName: null,
            options: [
              {
                keyValueID: "TriaCoverage",
                shortText: "TRIA Coverage",
                fullText: "TRIA Coverage",
                value: "Accepted",
                additionalInfo: null
              },
              {
                keyValueID: "CyberCoverage",
                shortText: "Cyber Suite Coverage",
                fullText: "Cyber Suite Coverage",
                value: "Accepted",
                additionalInfo: null
              },
              {
                keyValueID: "AdditionalChanges",
                shortText: "Additional Changes",
                fullText: "Additional Changes",
                value: "No additional changes needed",
                additionalInfo: null
              }
            ]
          }       
        ]
      }
    ],
    attachments: [],
    acknowledge: {
      terms: true,
      payPremium: true
    }
  };

  @ViewChild(BindAndIssueBasicInfoComponent, {static: false}) BindAndIssueBasicInfo:BindAndIssueBasicInfoComponent;
  @ViewChild(BindAndIssueReviewComponent, {static: false}) BindAndIssueReviewComponent:BindAndIssueReviewComponent;
  @ViewChild("cancelRenewalModal", {static: false}) cancelRenewalModal;
  @ViewChild("bindSubmitModal", {static: true}) bindSubmitModal: TemplateRef<any>;
  constructor(public readonly route: ActivatedRoute, private readonly router: Router,private renewalsService: RenewalsService, private modalService : NgbModal) { }

  ngOnInit() {
    /* Setting Headers Starts */
      this.headerData = new HeaderData();
      this.setHeaderData();
    /* Setting Headers Ended */

    this.route.paramMap.subscribe(params => {
      this.renewalNumber = parseInt(params.get("id"));
    });

    this.renewalAccountData = this.renewalsService.getRenewalAccountData();

    this._renewalsMethods = new RenewalBindMethods();
    this._renewal = new BindRenewal();
    this.renewalData = this._renewal.renewalData;

    this.renewalsService.setSupportingDocuments([]);
    this._renewal.selectedStep = RenewalSteps.BasicInfo;//RenewalSteps.Success;//RenewalSteps.Review;//
    this.bindRenewal = this._renewal;

    //this.renewalsService.storeRenewalBindData(this._renewal);
    this.fetchReferenceData();
  }

  setHeaderData(){
    this.headerData.pageTitle = "Bind Request";

    this.renewalsService.header = this.headerData;
  }

  /*** Fetch Lookup Reference Data to populate values on UI ***/
  fetchReferenceData(_filterDate: any = null) {
    this.loading = true;
    let referenceDataSubscription = this.renewalsService.fetchRenewalsLookupData().subscribe(response => {
      this.loading = false;
      this.lookupReferenceData = response;
    }, error=>{
      this.loading = false;
    });

    this.renewalsService.runningServices.push(referenceDataSubscription);
  }

  getContinueButtonName(){
    this._renewal = this.bindRenewal;
    if(this._renewal.selectedStep == this.RenewalSteps.BasicInfo){
      return "Continue to Review";
    }else if(this._renewal.selectedStep == this.RenewalSteps.Review){
      return "Submit";
    }
  }
  
  get selectedStep(){
    return this.renewalsService.selectedBindStep;
  }
  set selectedStep(_step){
    this._renewal.selectedStep = _step;
    this.renewalsService.selectedBindStep = _step;
  }

  get bindRenewal(){
    return this.renewalsService.bindRenewal;
  }
  set bindRenewal(_renewal){
    this.renewalsService.bindRenewal = _renewal;
  }
  
  getUploadedFileSize($event) {
    this.uploadedFileSize = $event;
  }

  public onCancel(){
    this.modalReference = this.modalService.open(this.cancelRenewalModal, { centered: true, backdropClass: 'light-blue-backdrop' });
    this.modalReference.result.then((result) => {
      console.log("closed");
      }, (reason) => {
        console.log("dismissed");
    });
  }

  cancelRenewal(){
    if(environment.logRocketKey){
      LogRocket.log("(LogRocket) BindRenewalRequest : " + true);
      let loggedInUser = this.renewalsService.getLoggedInProfile();
      LogRocket.identify(loggedInUser.UID.toString(), {
        BindRenewalRequest: true
      });
    }
    this.modalReference.close();
    this.router.navigate(["renewals/"+this.renewalNumber+ "/"+ this.renewalAccountData.data.accountNumber + "/manage"]);
  }
  
  onEdit() {
    this._renewal.selectedStep = RenewalSteps.BasicInfo;
    this._renewal.fromReview = true;
    this.bindRenewal = this._renewal;
    window.scrollTo(0, 0);
  }

  onContinue() {    
    this.isSubmitted = true;
    if (this.selectedStep == this.RenewalSteps.BasicInfo) {
      if (this.BindAndIssueBasicInfo.onContinue()) {
        this.selectedStep = this.RenewalSteps.Review;
        this.bindRenewal.selectedStep = this.RenewalSteps.Review;
        window.scrollTo(0, 0);
      }else{
        console.log("invalid basic info continue");
      }
    }else if(this.selectedStep == this.RenewalSteps.Review){
      if (this.BindAndIssueReviewComponent.onContinue()) {
        
        this._renewal = this.renewalsService.getRenewalBindData();
        
        this.bindRenewal = this._renewal;
        window.scrollTo(0, 0);

        console.log("uploading files");
        let newSupportingDocuments = [];
        this.loading = true;
        this.submitLoading = true;
        if(this.renewalsService.getSupportingDocuments().length>0){
          this.renewalsService.getSupportingDocuments().forEach((document, index) => {
             let newFile:any = {};
              newFile.name= document.name;
              newFile.lastModified= document.lastModified;
              newFile.lastModifiedDate= document.lastModifiedDate;
              newFile.webkitRelativePath= document.webkitRelativePath;
              newFile.size= document.size;
              newFile.type= document.type;
              newFile.docFileType = document.docFileType;
  
              ((_document, _newFile)=>{
                let fReader = new FileReader();
                // Add complete behavior
                fReader.onload = ()=>{
                  _newFile.content = fReader.result;
                  _newFile.content = _newFile.content.split("base64,")[1];
  
                  //console.log(_newFile.content);
                  newSupportingDocuments.push(_newFile);
  
                  if(newSupportingDocuments.length == this.renewalsService.getSupportingDocuments().length){
                    this.submitRequest(newSupportingDocuments);
                  }else{
                    console.log("uploading file " + index);
                  }
                };
                fReader.readAsDataURL(_document);
              })(document, newFile);   
          });
        }else{
          this.submitRequest([]);
        }
      }else{
        console.log("invalid basic info continue");
      }
    }
  }
  
  submitRequest(newSupportingDocuments){
    console.log("Submitting request");
    this.renewalsService.openModal('none', this.bindSubmitModal, false, 'dark-blue-backdrop', 'static', 'wait-modal', '', true);
    let finalRenewalData = this._renewalsMethods.getFinalBindRenewalData(this.bindRenewal);
    //let finalRenewalData = this.bniFormModel;
    finalRenewalData.attachments = newSupportingDocuments;
    let submitBindRenewalRequestSubscription = this.renewalsService.submitBind(finalRenewalData).subscribe(response=>{
      this.loading = false;
      this.submitLoading = false;
      this.renewalsService.closeModal();
      console.log("Submitted!!");

      this.finalResponse = response;
      console.log('finalResponse :: ', this.finalResponse);
      
      if(environment.logRocketKey){
        LogRocket.log("(LogRocket) BindRenewalRequestSubmitted : " + true);
        let loggedInUser = this.renewalsService.getLoggedInProfile();
        LogRocket.identify(loggedInUser.UID.toString(), {
          BindRenewalRequestSubmitted: true
        });
      }
      this.selectedStep = this.RenewalSteps.Success;
      this.bindRenewal.selectedStep = this.RenewalSteps.Success;

      this._renewal = new BindRenewal();
      this._renewal.selectedStep = this.RenewalSteps.Success;
      this.bindRenewal = this._renewal;
      //this.setHeaderData("Change Request Submitted", true);
      this.renewalsService.storeRenewalBindData({});
    },error=>{          
      this.loading = false;
      this.submitLoading = false;
      this.renewalsService.closeModal();
    }); 
    
    this.renewalsService.runningServices.push(submitBindRenewalRequestSubscription);
    console.log(finalRenewalData);
  }
}
